import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ProductList from './views/ProductList.vue'
import Cart from './views/Cart'
import CartModal from './views/CartModal'
import Checkout from './views/Checkout'
import Payment from './views/Payment'
import OrderConfirmation from './views/OrderConfirmation'
import EventTracking from './helpers/event-tracking'

Vue.use(Router)

const CartCheckoutRoutes = [
  {
    path: 'cart',
    component: CartModal,
    children: [
      {
        path: '/',
        component: Cart
      },
      {
        path: 'checkout',
        component: Checkout
      },
      {
        path: 'payment',
        component: Payment
      },
      {
        path: 'order',
        component: OrderConfirmation
      }
    ]
  }
]

const router = new Router({
  // export default new Router({
  base: window.vueBaseURL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: CartCheckoutRoutes
    },
    {
      path: '/products/:category',
      name: 'product-listing',
      component: ProductList,
      children: CartCheckoutRoutes
    },
    {
      path: '/products/',
      redirect: '/products/all'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (from.name === 'home' && to.name === 'product-listing') {
      return {
        selector: '#posabit-app',
        offset: {
          x: 0,
          y: 40
        }
      }
    } else {
      return savedPosition
    }
  }
})

router.afterEach((to, from) => {
  let path = to.path

  let cartPath = CartCheckoutRoutes[0].children.find(
    child => child.name === to.name
  )
  if (cartPath) {
    path = 'cart/' + cartPath.path.replace(/^\/+/g, '')
  }
  EventTracking.sendPageview(
    window.location.pathname.replace(/\/$/g, '') +
      '/#/' +
      path.replace(/^\/+/g, '')
  )
})

export default router
